import Handorgel from "handorgel";
const accEls = document.querySelectorAll(".acc");
let accs = [];

if (accEls && accEls.length) {
  accEls.forEach((el) => {
    const accordion = new Handorgel(el, {
      multiSelectable: false,

      // header/content class if fold is open
      headerOpenClass: "acc__header--open",
      contentOpenClass: "acc__content--open",

      // header/content class if fold has been opened (transition finished)
      headerOpenedClass: "acc__header--opened",
      contentOpenedClass: "acc__content--opened",

      // header/content class if fold has been focused
      headerFocusClass: "acc__header--focus",
      contentFocusClass: "acc__content--focus",

      // header/content class if fold is disabled
      headerDisabledClass: "acc__header--disabled",
      contentDisabledClass: "acc__content--disabled",
    });

    accordion.on("fold:close", (fold) => {
      fold.header.classList.add("acc__header--close");
    });
    accordion.on("fold:closed", (fold) => {
      fold.header.classList.remove("acc__header--close");
    });
    accordion.on("fold:open", (fold) => {
      fold.header.classList.remove("acc__header--close");
      closeOtherFolds(accordion);
    });
    accs.push(accordion);
  });
}

function closeOtherFolds(accordion) {
  accs.forEach((acc) => {
    if (acc != accordion) {
      if (acc.folds.length) {
        for (let index = 0; index < acc.folds.length; index++) {
          acc.folds[index].close();
        }
      }
    }
  });
}
